<script>import ButtonArrow from "./ButtonArrow.svelte";
import { attrValue } from "../../../../utils/html";
export let props = {};
</script>

<ButtonArrow
	props={{
		...props,
		classNames: attrValue([props.classNames, 'text-primary']),
		iconClassNames: 'bg-primary text-white'
	}}
	on:click
/>
